export default __webpack_public_path__ + "static/media/d_wdt_c_5.24bc1b12.mp3";